import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWordsWithRelatedWordsCreate } from '@shared/dto/+word/word_with_related_words/_requests/request_words_with_related_words_create';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { StateWords } from '../state_words';

export const remote_word_with_related_words_create = createAsyncThunkSafe<void, RequestWordsWithRelatedWordsCreate>(
  ENUM__network_event_client_to_server.WORD_WITH_WORDS_RELATED_CREATE,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORD_WITH_WORDS_RELATED_CREATE, request);
  },
);

export function init_remote_word_with_related_words_create(builder: ActionReducerMapBuilder<StateWords>) {
  builder
    .addCase(remote_word_with_related_words_create.pending, (state, action) => {})
    .addCase(remote_word_with_related_words_create.rejected, (state, action) => {})
    .addCase(remote_word_with_related_words_create.fulfilled, (state, action: PayloadAction) => {});
}
